export const periodOptions = [
    {"name": "Current day", "value": "currentday"},
    {"name": "Previous day", "value": "previousday"},
    {"name": "Current week", "value": "currentweek"},
    {"name": "Previous week", "value": "previousweek"},
    {"name": "Current month", "value": "currentmonth"},
    {"name": "Previous month", "value": "previousmonth"},
    {"name": "Current year", "value": "currentyear"}
];

export const DC_ZONE = {
    APAC: "APAC",
    EU: "EU",
    NA: "NA"
};